var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinusIconNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 2,
    viewBox: "0 0 14 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22222 2H7.77778H13.2222C13.4285 2 13.6263 1.89464 13.7722 1.70711C13.9181 1.51957 14 1.26522 14 1C14 0.734784 13.9181 0.48043 13.7722 0.292894C13.6263 0.105357 13.4285 0 13.2222 0H7.77778L7 0.000542323L6.74074 0L6.22222 9.60032e-05L0.777778 0C0.571498 0 0.373667 0.105357 0.227806 0.292894C0.0819442 0.48043 0 0.734784 0 1C0 1.26522 0.0819442 1.51957 0.227806 1.70711C0.373667 1.89464 0.571498 2 0.777778 2H6.22222Z",
    fill: "#009BD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIconNew);
export default __webpack_public_path__ + "static/media/minusIcon_new.dc543621d88d0a4544de5dee4b0cdc47.svg";
export { ForwardRef as ReactComponent };